const EXPAND_HEIGHT = 450;

// The clamped region's scrollHeight stays large once it has overflowed, and
// a multi-column box can report its single-column height. The columns
// element's border box is the height on screen.
function contentHeight(region: HTMLElement): number {
  const columns = region.querySelector<HTMLElement>(".extra-details-columns");
  return columns ? columns.offsetHeight : region.scrollHeight;
}

function bindExpand(region: HTMLElement): void {
  if (region.dataset.expandReady === "true") return;

  const button = region.nextElementSibling;
  if (!(button instanceof HTMLButtonElement)) return;

  region.dataset.expandReady = "true";
  button.style.display = "none";

  let expanded = false;

  const update = (): void => {
    if (expanded) return;
    const tall = contentHeight(region) > EXPAND_HEIGHT;
    region.classList.toggle("is-shortened", tall);
    button.style.display = tall ? "" : "none";
    if (tall) {
      button.removeAttribute("aria-hidden");
      button.removeAttribute("tabindex");
    } else {
      button.setAttribute("aria-hidden", "true");
      button.setAttribute("tabindex", "-1");
    }
  };

  update();
  requestAnimationFrame(update);
  // Images and the webfont change the height after the first measure.
  setTimeout(update, 100);
  if (document.fonts) document.fonts.ready.then(update);

  const measured = region.querySelector<HTMLElement>(".extra-details-columns") ?? region;
  if (typeof ResizeObserver !== "undefined") {
    new ResizeObserver(update).observe(measured);
  }

  button.addEventListener("click", () => {
    expanded = true;
    region.classList.remove("is-shortened");
    button.style.display = "none";
    button.setAttribute("aria-hidden", "true");
    button.setAttribute("tabindex", "-1");
  });
}

export function initArtistBio(root: ParentNode = document) {
  if (root instanceof Element && root.matches(".artist-bio, .extra-details")) {
    bindExpand(root);
  }
  root.querySelectorAll<HTMLElement>(".artist-bio, .extra-details").forEach(bindExpand);
}

function watchForInserted() {
  new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (node instanceof Element) initArtistBio(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
}

initArtistBio();
if (document.body) watchForInserted();
else document.addEventListener("DOMContentLoaded", watchForInserted);
